import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();

  // On first render after page reload, zustand may not have hydrated yet.
  // Check localStorage directly as a synchronous fallback.
  if (!isAuthenticated) {
    try {
      const raw = localStorage.getItem('auth-storage');
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed?.state?.token && parsed?.state?.isAuthenticated) {
          // Token exists in storage, zustand just hasn't hydrated yet -- show spinner
          return (
            <div className="flex flex-col items-center justify-center h-screen gap-3">
              <div className="w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
              <p className="text-gray-500">Loading...</p>
            </div>
          );
        }
      }
    } catch {}
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute;
